import React, { Component } from "react";
import PropTypes from "prop-types";
import { SelectField, FormField } from "../common/form-field";
import { reduxForm } from "redux-form";
import { Link } from "react-router-dom";
export const formName = "claimItemSelection";
import { intlShape, injectIntl, FormattedMessage } from "react-intl";
import messages from "components/messagesDescription";
import { Button } from "cxa-components";

class ClaimItemSelectionAlt extends Component {
  constructor(props) {
    super(props);
    this.openClaimExternal = this.openClaimExternal.bind(this);
  }

  getClaimFormUrl(claimId, benefitPeriod, selectedDelegator, getDonateCategory) {
    let link = `/claims/submit/${claimId}/${benefitPeriod}`;
    if (getDonateCategory) {
      link = `/donations/submit/${claimId}/${benefitPeriod}`;
    }

    if (selectedDelegator) {
      return link.concat(`/${selectedDelegator}`);
    }

    return link;
  }

  openClaimExternal(claimId, serviceProviderId, functionReferenceId) {
    const { getShortLivedToken, intl } = this.props;
    const text = intl.formatMessage({ ...messages.claims.externalClaimConfirmation });

    if (window.confirm(text)) {
      const wnd = window.open("", "_blank");
      getShortLivedToken().then(response => {
        const { body: { slToken } = {} } = response;
        if (!slToken) {
          return;
        }
        const url = `/sso/sp/submit-claim?serviceProviderId=${serviceProviderId}&slToken=${slToken}&functionReferenceId=${functionReferenceId}&claimItemId=${claimId}`;
        wnd.location = url;
        wnd.focus();
      });
    }
  }

  getClaimItemLink(item, benefitPeriod, functionReferenceId, selectedDelegator, getDonateCategory) {
    const { serviceProviderId, claimName, claimId } = item || {};
    const hasSPId = (serviceProviderId || "").length > 0;
    const text = <FormattedMessage id={claimName} defaultMessage={claimName} />;

    if (hasSPId) {
      return (
        <Button
          link
          type="button"
          onClick={() => this.openClaimExternal(claimId, serviceProviderId, functionReferenceId)}
        >
          {text}
        </Button>
      );
    } else {
      return (
        <Link
          to={this.getClaimFormUrl(claimId, benefitPeriod, selectedDelegator, getDonateCategory)}
        >
          {text}
        </Link>
      );
    }
  }

  render() {
    const {
      items,
      benefitPeriod,
      isServiceProviderClaimItem,
      isCPFEnabled,
      functionReferenceId,
      selectedDelegator,
      getDonateCategory,
    } = this.props;

    return (
      <div>
        <form method="POST" target="_blank" ref={frm => (this.frm = frm)}>
          <input type="hidden" name="SAMLResponse" ref={rawSaml => (this.rawSaml = rawSaml)} />
        </form>
        {items.map(group => (
          <section key={group.id}>
            {!isServiceProviderClaimItem && (
              <h3>
                <FormattedMessage
                  id={getDonateCategory ? "Donation" : group.label}
                  defaultMessage={getDonateCategory ? "Donation" : group.label}
                />
              </h3>
            )}

            {group.categories.map(category => {
              const { id, label, items } = category;
              return (
                <table key={id} className="data-table">
                  <thead>
                    <tr>
                      <th>
                        <FormattedMessage id={label} defaultMessage={label} />
                      </th>
                      <th className="field__mark">
                        <FormattedMessage {...messages.taxableDescription} />
                      </th>
                      {isCPFEnabled && (
                        <th className="field__mark">
                          <FormattedMessage {...messages.claims.cpfDescription} />
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {items.map(item => (
                      <tr key={item.claimId}>
                        <td>
                          {this.getClaimItemLink(
                            item,
                            benefitPeriod,
                            functionReferenceId,
                            selectedDelegator,
                            getDonateCategory
                          )}
                        </td>
                        <td>{item.isTaxable ? "✓" : ""}</td>
                        {isCPFEnabled && <td>{item.cpfContributable ? "✓" : ""}</td>}
                      </tr>
                    ))}
                  </tbody>
                </table>
              );
            })}
          </section>
        ))}
      </div>
    );
  }
}

ClaimItemSelectionAlt.propTypes = {
  items: PropTypes.array,
  benefitPeriod: PropTypes.string,
  isCPFEnabled: PropTypes.bool,
  intl: intlShape.isRequired,
  messages: PropTypes.object,
  getShortLivedToken: PropTypes.func,
  isServiceProviderClaimItem: PropTypes.bool,
  functionReferenceId: PropTypes.string,
  selectedDelegator: PropTypes.string,
  getDonateCategory: PropTypes.bool,
};

const ClaimItemSelectionForm = ({
  handleSubmit,
  benefitPlans,
  benefitPeriod,
  claimItems,
  isCPFEnabled,
  intl,
  getShortLivedToken,
  isServiceProviderClaimItem,
  functionReferenceId,
  employeesByDelegation,
  isEmployeesByDelegationEnabled,
  selectedDelegator,
  getDonateCategory,
}) => (
  <form onSubmit={handleSubmit}>
    <div>
      {isEmployeesByDelegationEnabled && (
        <SelectField
          label={intl.formatMessage(messages.claims.submitClaimFor)}
          name="employeesByDelegation"
          items={employeesByDelegation.map(item => ({
            value: item.employeeKey,
            label: intl.formatMessage({
              id: item.delegatedEmployeeName,
              defaultMessage: item.delegatedEmployeeName,
            }),
          }))}
        />
      )}

      {!isServiceProviderClaimItem && (
        <SelectField
          label={intl.formatMessage(messages.planYearDescription)}
          name="benefitPeriod"
          items={benefitPlans.map(item => ({
            value: item.id,
            label: item.name,
          }))}
        />
      )}
    </div>

    <FormField
      name="claimTypeId"
      benefitPeriod={benefitPeriod}
      component={ClaimItemSelectionAlt}
      items={claimItems}
      isCPFEnabled={isCPFEnabled}
      intl={intl}
      messages={messages}
      getShortLivedToken={getShortLivedToken}
      isServiceProviderClaimItem={isServiceProviderClaimItem}
      functionReferenceId={functionReferenceId}
      selectedDelegator={selectedDelegator}
      getDonateCategory={getDonateCategory}
    />
  </form>
);

ClaimItemSelectionForm.propTypes = {
  claimItems: PropTypes.array,
  benefitPlans: PropTypes.array,
  benefitPeriod: PropTypes.string,
  isCPFEnabled: PropTypes.bool,
  handleSubmit: PropTypes.func,
  intl: intlShape.isRequired,
  getShortLivedToken: PropTypes.func,
  isServiceProviderClaimItem: PropTypes.bool,
  functionReferenceId: PropTypes.string,
  employeesByDelegation: PropTypes.array,
  isEmployeesByDelegationEnabled: PropTypes.bool,
  selectedDelegator: PropTypes.string,
  getDonateCategory: PropTypes.bool,
};

export default injectIntl(
  reduxForm({
    form: formName,
    enableReinitialize: true,
  })(ClaimItemSelectionForm)
);



// WEBPACK FOOTER //
// ./components/claim/ClaimItemSelectionForm.js